import { types } from 'mobx-state-tree';
import PaymentWidget from './PaymentWidget';

const PaymentWidgetQueryResult = types.model('PaymentWidgetQueryResult', {
  widgets: types.optional(types.array(PaymentWidget), [])
});

export default PaymentWidgetQueryResult;
